export default __webpack_public_path__ + "dab9f232f247d4bb55792e282c98944d.png";